module.exports = __webpack_public_path__ + "static/img/top_people.96343069.png";